const MissingFonts = ['Lato', 'Open+Sans', 'Roboto+Slab', 'Overpass']
export const loadMissingFonts = () => {
  MissingFonts.forEach((font) => {
    const $linkTag = document.createElement('link')
    $linkTag.rel = 'stylesheet'
    $linkTag.href = `https://fonts.googleapis.com/css?family=${font}|${font}:bold&display=swap`
    document.body && document.body.appendChild($linkTag)
  })
}


// WEBPACK FOOTER //
// ./src/scripts/utils/fonts.js